import { useQuery } from '@apollo/client';
import { IHub } from '@transferz/fe-models';
import { IAirportDetails } from '@transferz/fe-models/src/transitTracking/transitTracking';

import { HUB_DETAILS_BY_ID } from '../hubTypeDefs';

interface IHubWithAirportDetails extends IHub {
  hubDetails: IAirportDetails;
}

export const useQueryHubDetailsById = (options?: any) => (
  useQuery<{ hubById: IHubWithAirportDetails }>(HUB_DETAILS_BY_ID, options)
);
